import {
  SEARCH_INPUT_CHANGE,
  SEARCH_INPUT_SUBMIT,
  SEARCH_INPUT_FOCUS,
  SEARCH_INPUT_BLUR,
} from './types';

export const onSearchInputChange = query => ({
  type: SEARCH_INPUT_CHANGE,
  query,
});

export const onSearchSubmit = query => ({
  type: SEARCH_INPUT_SUBMIT,
  query,
});

export const onSearchFocus = {
  type: SEARCH_INPUT_FOCUS,
};

export const onSearchBlur = {
  type: SEARCH_INPUT_BLUR,
};



// WEBPACK FOOTER //
// ./src/search/actions.js